import { render } from "./TopBox.vue?vue&type=template&id=4cf16c85&scoped=true"
import script from "./TopBox.vue?vue&type=script&lang=js"
export * from "./TopBox.vue?vue&type=script&lang=js"

import "./TopBox.vue?vue&type=style&index=0&id=4cf16c85&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf16c85"]])

export default __exports__